// extracted by mini-css-extract-plugin
export var article = "article-template-module--article--wftNg";
export var articlesMenu = "article-template-module--articlesMenu--y5-iT";
export var container = "article-template-module--container--OtwDw";
export var contentContainer = "article-template-module--contentContainer--cJNqe";
export var headerContainer = "article-template-module--headerContainer--NaCrk";
export var myImage = "article-template-module--my-image--53f3s";